module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-ties-remnants.af1a1f05.png";